import { mode, transparentize } from '@chakra-ui/theme-tools';
const getBaseStyle = (props) => {
    const { theme } = props;
    return {
        '> *:first-of-type:not(:last-of-type)': {
            borderRightRadius: 0,
            borderRight: '1px solid',
            borderColor: mode(transparentize('gray.500', 0.24)(theme), transparentize('white', 0.24)(theme))(props),
        },
        '> *:not(:first-of-type):not(:last-of-type)': {
            borderRadius: 0,
            borderRight: '1px solid',
            borderColor: mode(transparentize('gray.500', 0.24)(theme), transparentize('white', 0.24)(theme))(props),
        },
        '> *:not(:first-of-type):last-of-type': { borderLeftRadius: 0 },
    };
};
export default {
    baseStyle: getBaseStyle,
};
//# sourceMappingURL=toolbar-button-group.js.map